// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9278633f","453":"16338729","455":"af346196","977":"87dc5ad1"}[chunkId] + ".chunk.js";
};